import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e14645a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "addActivity",
  tabindex: "-1",
  "aria-labelledby": "addActivity",
  "aria-hidden": "true",
  "data-bs-focus": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-lg" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title w-100 text-center fw-bold break-word" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1))
const _hoisted_7 = { class: "mb-3 row" }
const _hoisted_8 = { class: "d-flex align-items-start col-lg-3 mt-2" }
const _hoisted_9 = { class: "form-label mb-0 me-3 col-lg-8" }
const _hoisted_10 = { class: "col-lg-9" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_13 = { class: "mb-3 row" }
const _hoisted_14 = { class: "d-flex align-items-start col-lg-3 mt-2" }
const _hoisted_15 = { class: "form-label mb-0 me-3 col-lg-8" }
const _hoisted_16 = { class: "col-lg-9 d-flex flex-sm-row flex-column" }
const _hoisted_17 = { class: "w-100 me-2 mb-sm-0 mb-3" }
const _hoisted_18 = { class: "input-group" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_20 = { class: "w-100" }
const _hoisted_21 = { class: "input-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-append" }, [
  /*#__PURE__*/_createElementVNode("label", {
    class: "input-group-text cursor-pointer h-100",
    for: "select-birthday",
    type: "button",
    title: "Toggle",
    "data-toggle": ""
  }, [
    /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-alt" })
  ])
], -1))
const _hoisted_23 = { class: "mb-3 row" }
const _hoisted_24 = { class: "d-flex align-items-start col-lg-3 mt-2" }
const _hoisted_25 = { class: "form-label mb-0 me-3 col-lg-8" }
const _hoisted_26 = { class: "col-lg-9" }
const _hoisted_27 = ["placeholder"]
const _hoisted_28 = {
  key: 0,
  class: "invalid-feedback"
}
const _hoisted_29 = { class: "row mx-0 px-0 mb-4 d-flex justify-content-center flex-lg-row flex-column-reverse" }
const _hoisted_30 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_31 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }

import { computed, PropType, ref, watch, watchEffect, onMounted, nextTick } from 'vue'
import { required, minLength } from '@vuelidate/validators'
import { customMaxLength, scrollToErrors } from '@/utils'
import useVuelidate from '@vuelidate/core'
import flatPickr from 'vue-flatpickr-component'
import dayjs from 'dayjs'
import { useStore } from 'vuex'

import Button from '@/components/button/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import EditActivitySuccessModal from '@/views/user/account/portfolio/components/EditActivitySuccessModal.vue'
import ConfirmActivitiesModal from '@/views/user/account/portfolio/components/EditActivityConfirmModal.vue'

import { DEFAULT_MIN_LENGTH } from '@/constants/number'
import { translate } from '@/languages/i18n'
import { configYMPortfolio } from '@/constants/datepicker'
import { COMMUNITY_PORTFOLIOS_STORE, ROOT_STORE } from '@/store/constants'
import { REGEX_EMOJI } from '@/constants/regex'
import Status from '@/components/status/index.vue'
import { debounce } from 'lodash'
import commonService from '@/services/common.service'
import { Modal } from 'bootstrap'
import _, { cloneDeep } from 'lodash'


export default /*#__PURE__*/_defineComponent({
  props: {
  id: String,
  handleEditActivities: Function as PropType<any>,
},
  setup(__props) {

const props = __props

const isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
const isSameOrAfter = require('dayjs/plugin/isSameOrAfter')

dayjs.extend(isSameOrBefore)
dayjs.extend(isSameOrAfter)



const store = useStore()

const activities = computed(() => store.getters[COMMUNITY_PORTFOLIOS_STORE.GETTERS.ACTIVITIES_PORTFOLIOS])
const isMobile = computed(() => store.getters[ROOT_STORE.GETTERS.CHECK_MOBILE_DEVICE])

const serverErrorActivities = ref('')
const requiredFromDate = ref(true)
const keepContentModal = ref(false)
const activitiesModal = ref()

onMounted(() => {
  activitiesModal.value = new Modal(document.getElementById('addActivity'))
  activitiesModal.value._element.addEventListener('hide.bs.modal', resetDataEdit)
})

const responseServerError = (type: string): void => {
  serverErrorActivities.value = type
}

const rules = computed(() => {
  return {
    title: {
      required,
      maxLength: (value: string) => customMaxLength(value, 20),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    content: {
      required,
      minLength: minLength(DEFAULT_MIN_LENGTH),
      maxLength: (value: string) => customMaxLength(value, 200),
      pictograms: function (value) {
        if (value) {
          return REGEX_EMOJI.test(value)
        } else {
          return true
        }
      },
    },
    fromDate: {
      required,
      maxDateNyears: function (value) {
        const date = dayjs().add(10, 'year').startOf('month').format('YYYY-MM-DD')
        const datePast = dayjs('1900/01/01').format('YYYY-MM-DD')

        if (dayjs(date).isBefore(dayjs(value))) {
          return false
        }
        if (dayjs(value).isBefore(dayjs(datePast))) {
          return false
        }
        return true
      },
    },
    toDate: {
      maxDateNyears: function (value) {
        const date = dayjs().add(10, 'year').startOf('month').format('YYYY-MM-DD')
        const datePast = dayjs('1900/01/01').format('YYYY-MM-DD')

        if (dayjs(date).isBefore(dayjs(value))) {
          return false
        }
        if (dayjs(value).isBefore(dayjs(datePast))) {
          return false
        }
        return true
      },
      afterStartDate: function (value) {
        return value ? dayjs(value).isSameOrAfter(dayjs(formData.value.fromDate)) : true
      },
    },
  }
})

const formData = ref({
  title: '',
  content: '',
  fromDate: '',
  toDate: '',
})

const v$ = useVuelidate(rules, formData)
const dataSubmit = ref({})
const confirmActivitiesModal = ref(null)

const onSubmit = async (): Promise<void> => {
  v$.value.$touch()
  if (!formData.value.fromDate) {
    requiredFromDate.value = true
  }

  isCheckedNGTitle.value = false
  isCheckedNGContent.value = false
  await checkNGTitle()
  await checkNGContent()
  while (!isCheckedNGTitle.value || !isCheckedNGContent.value) {
    await new Promise((resolve) => setTimeout(resolve, 200))
  }

  if (v$.value.$invalid || ngKeyTitle.value || ngKeyContent.value) {
    nextTick(() => {
      scrollToErrors('.invalid-feedback', '#addActivity')
    })
    return
  }
  const data = cloneDeep(formData.value)
  keepContentModal.value = true
  activitiesModal.value?.hide()
  confirmActivitiesModal.value.showConfirmModal()
  dataSubmit.value = data
}

const resetForm = (): void => {
  v$.value.$reset()
  Object.assign(formData.value, {
    title: '',
    content: '',
    fromDate: null,
    toDate: null,
  })
  requiredFromDate.value = false
  ngKeyTitle.value = false
  ngKeyContent.value = false
  props.handleEditActivities('')
}

watch(
  () => props.id,
  () => {
    if (!props.id) {
      formData.value = {
        title: '',
        content: '',
        fromDate: '',
        toDate: '',
      }
    } else {
      const itemActivity = activities.value.filter((item: any) => Number(item.id) === Number(props.id))[0]
      formData.value = {
        title: itemActivity?.title || '',
        content: itemActivity?.content || '',
        fromDate: itemActivity?.start_period || dayjs().startOf('month').format('YYYY-MM-DD'),
        toDate: itemActivity?.end_period || '',
      }
    }
  }
)

watchEffect(() => {
  if (formData.value.fromDate) {
    requiredFromDate.value = true
  }
})
const isCheckedNGTitle = { value: false }
const ngKeyTitle = ref<boolean>(false)
const checkNGTitle = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.title.$model })
  ngKeyTitle.value = data.data?.data?.has_ngword
  isCheckedNGTitle.value = true
}, 200)

const isCheckedNGContent = { value: false }
const ngKeyContent = ref<boolean>(false)
const checkNGContent = debounce(async () => {
  const data = await commonService.sendNGWordCheck({ sentence: v$.value.content.$model })
  ngKeyContent.value = data.data?.data?.has_ngword
  isCheckedNGContent.value = true
}, 200)

const resetDataEdit = () => {
  if (keepContentModal.value) return
  if (props.id) {
    const itemActivity = activities.value.filter((item: any) => Number(item.id) === Number(props.id))[0]
    v$.value.$reset()
    formData.value = {
      title: itemActivity?.title || '',
      content: itemActivity?.content || '',
      fromDate: itemActivity?.start_period || dayjs().startOf('month').format('YYYY-MM-DD'),
      toDate: itemActivity?.end_period || '',
    }
    ngKeyTitle.value = false
    ngKeyContent.value = false
  }
}

const onHideModalConfirm = (getBack) => {
  keepContentModal.value = false
  if (getBack) {
    activitiesModal.value.show()
    return
  }
  resetDataEdit()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Button, {
      onClick: resetForm,
      title: _unref(translate)('addPersonalActivities'),
      type: 'secondary',
      "data-bs-toggle": 'modal',
      "data-bs-target": '#addActivity'
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(__props.id ? _unref(translate)('SG43editActivity') : _unref(translate)('SG43addActivity')), 1),
            _hoisted_6
          ]),
          _createElementVNode("form", {
            onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
            class: "modal-body"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(translate)('activityTitle')), 1),
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  name: "title",
                  class: _normalizeClass(['form-control', ngKeyTitle.value || _unref(v$).title.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).title.$model) = $event)),
                  placeholder: _unref(translate)('placeholder'),
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(checkNGTitle) && _unref(checkNGTitle)(...args)))
                }, null, 42, _hoisted_11), [
                  [
                    _vModelText,
                    _unref(v$).title.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyTitle.value && !_unref(v$).title.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('activityTitle'),
                  params: [1, 20],
                  validator: _unref(v$).title.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(translate)('activityPeriod')), 1),
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    (props.id && _unref(v$).fromDate.$model)
                      ? (_openBlock(), _createBlock(_unref(flatPickr), {
                          key: 0,
                          modelValue: _unref(v$).fromDate.$model,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).fromDate.$model) = $event)),
                          config: _unref(configYMPortfolio)(_unref(v$).fromDate.$model),
                          placeholder: "2000/01",
                          class: _normalizeClass(['form-control bg-white', _unref(v$).fromDate.$error ? 'is-invalid' : ''])
                        }, null, 8, ["modelValue", "config", "class"]))
                      : (_openBlock(), _createBlock(_unref(flatPickr), {
                          key: 1,
                          modelValue: _unref(v$).fromDate.$model,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).fromDate.$model) = $event)),
                          config: _unref(configYMPortfolio)(new Date()),
                          placeholder: "2000/01",
                          class: _normalizeClass(['form-control bg-white', _unref(v$).fromDate.$error ? 'is-invalid' : ''])
                        }, null, 8, ["modelValue", "config", "class"])),
                    _hoisted_19
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: '開始日',
                    validator: requiredFromDate.value ? _unref(v$).fromDate.$errors[0]?.$validator : '',
                    params: [1900, 1, 10]
                  }, null, 8, ["validator"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    (props.id && _unref(v$).toDate.$model)
                      ? (_openBlock(), _createBlock(_unref(flatPickr), {
                          key: 0,
                          modelValue: _unref(v$).toDate.$model,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).toDate.$model) = $event)),
                          config: _unref(configYMPortfolio)(_unref(v$).toDate.$model),
                          placeholder: "2000/01",
                          class: _normalizeClass(['form-control bg-white', _unref(v$).toDate.$error ? 'is-invalid' : ''])
                        }, null, 8, ["modelValue", "config", "class"]))
                      : (_openBlock(), _createBlock(_unref(flatPickr), {
                          key: 1,
                          modelValue: _unref(v$).toDate.$model,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).toDate.$model) = $event)),
                          config: _unref(configYMPortfolio)(new Date()),
                          placeholder: "2000/01",
                          class: _normalizeClass(['form-control bg-white', _unref(v$).toDate.$error ? 'is-invalid' : ''])
                        }, null, 8, ["modelValue", "config", "class"])),
                    _hoisted_22
                  ]),
                  _createVNode(InputErrorMessage, {
                    title: '終了',
                    validator: _unref(v$).toDate.$errors[0]?.$validator,
                    params: [1900, 1, 10]
                  }, null, 8, ["validator"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("label", _hoisted_25, _toDisplayString(_unref(translate)('specificsContent')), 1),
                _createVNode(Status)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  name: "content",
                  class: _normalizeClass(['form-control', ngKeyContent.value || _unref(v$).content.$error ? 'is-invalid' : '']),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).content.$model) = $event)),
                  placeholder: _unref(translate)('roleEtc'),
                  onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_unref(checkNGContent) && _unref(checkNGContent)(...args)))
                }, null, 42, _hoisted_27), [
                  [
                    _vModelText,
                    _unref(v$).content.$model,
                    void 0,
                    { trim: true }
                  ]
                ]),
                (ngKeyContent.value && !_unref(v$).content.$error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(_unref(translate)('ngKeyWord')), 1))
                  : _createCommentVNode("", true),
                _createVNode(InputErrorMessage, {
                  title: _unref(translate)('specificsContent'),
                  params: [1, 200],
                  validator: _unref(v$).content.$errors[0]?.$validator
                }, null, 8, ["title", "validator"])
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, [
                _createVNode(Button, {
                  "data-bs-dismiss": "modal",
                  onClick: resetForm,
                  title: _unref(translate)('cancel'),
                  type: 'secondary',
                  className: 'button-confirm-modal'
                }, null, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(Button, {
                  class: "button-submit",
                  type: 'secondary',
                  title: _unref(translate)(!__props.id ? 'signUp' : 'update'),
                  onClick: onSubmit
                }, null, 8, ["title"])
              ])
            ])
          ], 32)
        ])
      ])
    ]),
    _createVNode(ConfirmActivitiesModal, {
      responseServerError: responseServerError,
      data: dataSubmit.value,
      id: __props.id,
      reset: resetForm,
      ref: (_value, _refs) => {
        _refs['confirmActivitiesModal'] = _value
        confirmActivitiesModal.value = _value
      },
      onOnHideModalConfirm: onHideModalConfirm
    }, null, 8, ["data", "id"]),
    _createVNode(EditActivitySuccessModal, {
      reset: resetForm,
      serverErrorActivities: serverErrorActivities.value,
      id: __props.id
    }, null, 8, ["serverErrorActivities", "id"])
  ], 64))
}
}

})